import { JSX } from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

interface Props {
  label: string | null;
  sx?: SxProps<Theme>;
}

export default function InstanceBadge({
  label,
  sx,
}: Props): JSX.Element | null {
  if (!label) {
    return null;
  }
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        bgcolor: 'primary.lighter',
        color: 'primary.darker',
        borderRadius: '20px',
        px: 1.5,
        py: 0.625,
        ...sx,
      }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: 'inherit' }}>
        {label}
      </Typography>
    </Box>
  );
}
